/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsMDRMostRecentAlert
 */
export interface JumboStructsMDRMostRecentAlert {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMDRMostRecentAlert
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMDRMostRecentAlert
     */
    endpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMDRMostRecentAlert
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsMDRMostRecentAlert
     */
    type?: string;
}

/**
 * Check if a given object implements the JumboStructsMDRMostRecentAlert interface.
 */
export function instanceOfJumboStructsMDRMostRecentAlert(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsMDRMostRecentAlertFromJSON(json: any): JumboStructsMDRMostRecentAlert {
    return JumboStructsMDRMostRecentAlertFromJSONTyped(json, false);
}

export function JumboStructsMDRMostRecentAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsMDRMostRecentAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function JumboStructsMDRMostRecentAlertToJSON(value?: JumboStructsMDRMostRecentAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'endpoint': value.endpoint,
        'name': value.name,
        'type': value.type,
    };
}

